import { Megaphone } from "lucide-react";

import { maintenanceMessages } from "../maintenance.intl";
import type { MaintenanceHistoryEntry } from "../types/maintenance.types";

import { useIntlMessages } from "@/app/hooks/useIntlMessages";
import MaintenanceSVG from "@/assets/images/maintenance-window-animation.svg";

interface MaintenanceDowntimePageProps {
  schedule: MaintenanceHistoryEntry | null;
}

const MaintenanceDowntimePage = (
  props: MaintenanceDowntimePageProps,
): JSX.Element => {
  const { schedule } = props;
  const t = useIntlMessages(maintenanceMessages);

  return (
    <main className='flex min-h-screen items-center justify-center bg-white px-6 py-12'>
      <section className='flex w-full max-w-md flex-col items-center text-center'>
        <div className='mb-8'>
          <img
            src={MaintenanceSVG}
            className={`${`size-[${200}px]`} self-center`}
            alt={t("downtimeTitle")}
            loading='eager'
          />
        </div>
        <h1 className='text-3xl font-semibold text-slate-950'>
          {t("downtimeTitle")}
        </h1>
        <p className='mt-4 text-base leading-7 text-slate-500'>
          {t("downtimeDescription")}
        </p>

        {schedule?.notice && (
          <div className='mt-10 w-full rounded-md border border-slate-200 p-5 text-left'>
            <div className='flex items-center gap-3 font-medium text-slate-800'>
              <span className='grid size-9 place-items-center rounded-full bg-blue-50 text-primary'>
                <Megaphone size={18} />
              </span>
              {t("notice")}
            </div>
            <p className='mt-5 border-t border-slate-200 pt-4 text-sm leading-6 text-slate-700'>
              {schedule.notice}
            </p>
          </div>
        )}
      </section>
    </main>
  );
};

export default MaintenanceDowntimePage;
